import Container from 'saur_ui_library/src/Atoms/Container/Container';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  margin-top: 50px;
`;

export const Styles = createGlobalStyle`
.h2s-global-container.sds-reset-style{
.global-card-container{
  .pi{
    font-family: 'primeicons';
  }
  flex-direction: row;
  justify-content: space-between;
  width: 70vw;
  margin-left: auto;
  margin-right: auto;
  .card-data,.card-notation,.card-inspection{
    overflow:visible;
    background-color: #F5F8FB;
    .card-title{
    margin-bottom: 15px;
    align-self: center;
    }
    .datePick{
      .DatePicker__calendarContainer{
        position: relative;
        margin-top: 10px;
          }
    }
    .datePick, .datePick2{
      .DatePicker {
          width: 100%;
        }
    }

  }
  .data-container,.notation-container,.inspection-container{
    width: 30%;
  }
}

.h2s-btn{
  margin: 50px auto;
}
.error{
  color: red;
}
.blueline{
    border: 0.5px solid #008BD2;
    background-color:  #008BD2;
    width: 90%;
    align-self: center;
  }
  .notation-title{
    flex-direction: row;
    justify-content: space-around;
    .notation-title-word{

    }
  }
  .notation-word{
    align-self: center;
    margin-top: 20px;
  }

.visite-radiolist,.pr-sensible-radiolist,
.presence-radiolist,.itv-radiolist,
.facteur-radiolist,.degradation-radiolist,
.mesure-radiolist, .compressor-radiolist, .treatment-device-radiolist{
    flex-direction: row;
    justify-content: space-around;
    width: 70px;
    margin-bottom:20px;
    margin-top: 5px; 
    margin-left: 50px;
  .radio-item{
    align-items: normal !important;
    margin-right: 20px;
    .radio-item-label{
      margin-left: 5px;
    }
    } 
  }
  .bachees,.dco-temp{
    flex-direction: row;
    justify-content: space-around;
  input.p-inputtext.p-component.p-inputnumber-input{
    width: 110px;
    }
  }

  .notation-input{
      flex-direction: row;
      justify-content: space-around;
  }

  .temps-sejour-input input, .vol-refoule-input input,
  .vitesse-autocurage-input input{
    border: 1px solid #CCE8F6;
    border-radius: 5px;
    width: 63px !important;
    height:43px;
    text-align: center;
    background-color: white;
    margin-top: 10px;
  }
  .sds-m-modern-date-picker .my-custom-input{
    background-color:#edf2fa;
    border-radius: 0%;
  }
  .p-inputswitch{
    width: 48px;
    height: 28px;
   .p-inputswitch-slider:before {
    width: 20px;
    height: 20px;
    left: 4px;
    margin-top: -10px;
    }
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    -webkit-transform: translateX(18px);
    transform: translateX(18px);
  }
}
`;
